import React from 'react';
import moment from 'moment';
import { ICloudSourceRunStatus } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import { FixMe } from '@utils/types';
import Text from '@ui-library/table/components/text';
import JobTitle from '../cloudSourceStatusTab/statusTitle';
import StatusTable, { sourceStatusCommonColumns } from '../cloudSourceStatusTab/StatusTable';

interface CloudSourceRunHistoryProps {
  data?: ICloudSourceRunStatus[];
  loading?: boolean;
}

const CloudSourceRunHistory = ({ data, loading }: CloudSourceRunHistoryProps) => {
  let sourceRunColumns: FixMe[] = [
    {
      title: 'Run id',
      dataIndex: 'jobRunId',
      width: '40%',
      key: 'jobRunId',
      render: (value: string, record: FixMe) => (
        <Text
          name={
            <JobTitle
              title={value}
              error={record.error}
              done={
                !!(record.finishedAt && moment(record.finishedAt).isAfter(moment(record.startedAt)))
              }
            />
          }
        />
      ),
    },
    ...sourceStatusCommonColumns,
  ];
  const exportCountExists = data
    ?.filter((v) => !v.taskRunId)
    .some((v: FixMe) => typeof v.exportedCount === 'number');
  if (exportCountExists) {
    sourceRunColumns = [
      ...sourceRunColumns,
      {
        key: 'exportedCount',
        title: 'Exported Count',
        dataIndex: 'exportedCount',
        render: (value: FixMe) => (typeof value === 'number' ? value : '-'),
      },
    ];
  }
  return (
    <StatusTable
      key={sourceRunColumns.length}
      loading={loading || !data}
      columns={sourceRunColumns}
      data={data}
    />
  );
};

export default CloudSourceRunHistory;
